module.exports = __webpack_public_path__ + "img/giphy.c675ae02.gif";